import {
  ComputedRoute,
  PrintableArrowDownwardIcon,
  PrintableArrowUpwardIcon,
  Route,
} from '@geovelo-frontends/commons';
import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import { Chart } from 'chart.js';
import React from 'react';
import { useTranslation } from 'react-i18next';

const styles = StyleSheet.create({
  wrapper: {
    flexDirection: 'row',
    marginTop: 30,
  },
  row: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  icon: {
    marginRight: 4,
    height: 12,
    width: 12,
  },
  chart: {
    height: 100,
    marginLeft: 30,
  },
});

interface IProps {
  elevationChart: Chart | undefined;
  route: ComputedRoute | Route;
}

function Elevation({
  route: { verticalGain, verticalLoss },
  elevationChart,
}: IProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <View style={styles.wrapper}>
      <View>
        <Text>{t('commons.routing.detail.elevation_profile')}</Text>
        <View style={styles.row}>
          <PrintableArrowUpwardIcon color="#000" height={12} style={styles.icon} width={12} />
          <Text>{verticalGain} m</Text>
        </View>
        <View style={styles.row}>
          <PrintableArrowDownwardIcon color="#000" height={12} style={styles.icon} width={12} />
          <Text>{verticalLoss} m</Text>
        </View>
      </View>
      <Image src={elevationChart?.toBase64Image('image/png', 1)} style={styles.chart} />
    </View>
  );
}

export default Elevation;
